// "Тести" — хаб режимів тренування (та сама вітрина, що й на головній).
import { api } from '../lib/api';
import { useFetch } from '../lib/useFetch';
import { PageHeader } from '../components/PageHeader';
import { ModeGrid } from '../components/ModeGrid';
import { Loader } from '../components/Loader';
import { ErrorView } from '../components/ErrorView';

export function Categories() {
  const { data, loading, error, reload } = useFetch(() => api.me(), []);

  return (
    <>
      <PageHeader title="Тести" subtitle="Вчи по темах → Тренуйся → Складай іспит" />
      <div className="p-4">
        {loading && <Loader />}
        {error && <ErrorView error={error} onRetry={reload} />}
        {data && (
          <ModeGrid
            isPremium={data.user.isPremium}
            mistakes={data.stats.mistakesCount}
            bookmarks={data.stats.bookmarksCount}
          />
        )}
      </div>
    </>
  );
}
